import {
  SET_IS_FETCHING_FORGOT_PASSWORD,
  SET_IS_FORGOT_PASSWORD_SUCCESS,
  SET_IS_FORGOT_PASSWORD_ERROR,
  RESET_FORGOT_PASSWORD_REQUEST,
} from "./actions-types";

import { forgotPasswordService } from "../services";

const setIsFetchingPassword = ({ isFetching }) => ({
  type: SET_IS_FETCHING_FORGOT_PASSWORD,
  payload: { isFetching },
});

export const setForgotPasswordSuccess = ({ isSuccess }) => ({
  type: SET_IS_FORGOT_PASSWORD_SUCCESS,
  payload: { isSuccess },
});

const setForgotPasswordError = ({ isError }) => ({
  type: SET_IS_FORGOT_PASSWORD_ERROR,
  payload: { isError },
});

export const fetchForgotPassword =
  ({ email }) =>
  async (dispatch) => {
    try {
      dispatch(setForgotPasswordError({ isError: false }));
      dispatch(setIsFetchingPassword({ isFetching: false }));
      await forgotPasswordService({ email });

      dispatch(setForgotPasswordSuccess({ isSuccess: true }));
    } catch (e) {
      dispatch(setForgotPasswordError({ isError: true }));
    } finally {
      dispatch(setIsFetchingPassword({ isFetching: false }));
    }
  };

export const resetForgotPasswordRequest = () => ({
  type: RESET_FORGOT_PASSWORD_REQUEST,
});
